import { jsx, jsxs } from 'react/jsx-runtime';
import { useMemo } from 'react';
import cns from '../../../../node_modules/classnames/index.js';
import Highlighter from '../../../Highlighter/Highlighter.js';

/**
 * Componente di una lista
*/
function Item({ title = undefined, description = undefined, highlightedText = undefined, classname = undefined, }) {
    const titleComp = useMemo(() => {
        const clazz = 'v2-select-field__item-content-title text-regular';
        if (typeof title === 'string' && highlightedText) {
            return jsx(Highlighter, { className: clazz, text: title || '', value: highlightedText || '' });
        }
        return jsx("span", { className: clazz, children: title });
    }, [highlightedText, title]);
    const descriptionComp = useMemo(() => {
        const clazz = 'v2-select-field__item-content-description text-regular';
        if (typeof description === 'string' && highlightedText) {
            return jsx(Highlighter, { className: clazz, text: description || '', value: highlightedText || '' });
        }
        return jsx("span", { className: clazz, children: description });
    }, [highlightedText, description]);
    return (jsxs("div", { className: cns('v2-select-field__item-content', classname), children: [titleComp, descriptionComp] }));
}

export { Item as default };
